


































import { namespace } from 'vuex-class'
import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import NoEmptyField from '@/UI/Shared/NoEmptyField.vue'
import AlreadyPresentedSelector from '@/UI/Auction/Documentations/AlreadyPresentedSelector.vue'
import AnoField from '@/UI/Shared/AnoField.vue'

const auctionStore = namespace('auction')
@Component({
  components: {
    NoEmptyField,
    AnoField,
    AlreadyPresentedSelector
  }
})
export default class DocumentationsPresented extends Vue {
  currentProcedureCode = ''
  currentProcedureYear = ''
  currentProcedureOrgano = ''
  organoValid = false
  codProcedementoValid = false
  anoValid = false
  blockedManualDocumentation = false

  @auctionStore.Getter
  public applicantNif!: string

  @Prop({ type: Number, required: true }) readonly documentId!: number
  @Prop({ type: String, default: '' }) readonly procedureCode!: string
  @Prop({ type: String, default: '' }) readonly procedureYear!: string
  @Prop({ type: String, default: '' }) readonly procedureOrgano!: string
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  get isValidData (): boolean {
    return this.organoValid && this.anoValid && this.codProcedementoValid
  }

  @Watch('procedureOrgano')
  onProcedureOrganoChanged (newValue: string): void {
    this.currentProcedureOrgano = newValue
  }

  @Watch('procedureCode')
  onProcedureCodeChanged (newValue: string): void {
    this.currentProcedureCode = newValue
  }

  @Watch('procedureYear')
  onProcedureYearChanged (newValue: string): void {
    this.currentProcedureYear = newValue
  }

  created (): void {
    this.currentProcedureCode = this.procedureCode
    this.currentProcedureYear = this.procedureYear
    this.currentProcedureOrgano = this.procedureOrgano
  }

  onOrganoUpdated ($event: boolean): void {
    this.organoValid = $event
    this.infoUpdate()
  }

  onProcedureCodeUpdated ($event: boolean): void {
    this.codProcedementoValid = $event
    this.infoUpdate()
  }

  onYearUpdated ($event: boolean): void {
    this.anoValid = $event
    this.infoUpdate()
  }

  infoUpdate (): void {
    const data = {
      organo: this.isValidData ? this.currentProcedureOrgano : '',
      codProcedemento: this.isValidData ? this.currentProcedureCode : '',
      ano: this.isValidData ? this.currentProcedureYear : '',
      alreadyInCorpu: this.isValidData ? this.blockedManualDocumentation : false
    }
    this.$emit('documentation-info-updated', data)
  }

  onProcedureSelected ($event: { procedure: string, year: string }): void {
    this.blockedManualDocumentation = !!$event.procedure
    this.organoValid = $event.procedure !== ''
    this.codProcedementoValid = $event.procedure !== ''
    this.anoValid = $event.procedure !== ''
    this.currentProcedureOrgano = $event.procedure ? 'Servicio de Montes' : ''
    this.currentProcedureCode = $event.procedure
    this.currentProcedureYear = $event.year
    this.infoUpdate()
  }
}
